import { type StateCreator, type StoreApi, type UseBoundStore, create as zustandCreate } from "zustand";

type ResetCallback = () => void;
interface IResettable {
  reset: () => void;
}

const resetters: ResetCallback[] = [];

export const create = <TState>(
  initializer: StateCreator<TState, [], [["zustand/devtools", never], ["zustand/persist", unknown]], TState>
): UseBoundStore<StoreApi<TState>> => {
  const slice: UseBoundStore<StoreApi<TState>> = zustandCreate(initializer as never);
  const initialState = slice.getState();

  const isResettable = Object.prototype.hasOwnProperty.call(initialState, "reset");
  if (isResettable) {
    resetters.push(() => {
      (slice.getState() as unknown as IResettable).reset();
    });
  }

  return slice;
};

export const resetAllSlices = (): void => {
  for (const resetter of resetters) {
    resetter();
  }
};
